import type { Stage, Tier } from "./types";

export const tierLabels: Record<Tier, string> = {
  tier_1: "Acquisition System",
  tier_2: "Brand Awareness",
};

export const stagesByTier: Record<Tier, Stage[]> = {
  tier_1: [
    { key: "signed", label: "Signed & invoiced", summary: "Agreement and initial payment confirmed" },
    { key: "access", label: "Access granted", summary: "Required accounts and permissions connected" },
    { key: "intake", label: "Brand & business intake", summary: "Offer, audience, and business details collected" },
    { key: "a2p", label: "A2P submitted", summary: "Messaging registration is in review" },
    { key: "build", label: "Landing page & offer", summary: "Campaign foundation is being assembled" },
    { key: "creative-call", label: "Creative call", summary: "Direction and production plan confirmed" },
    { key: "production", label: "In production", summary: "Campaign assets are being produced" },
    { key: "gate", label: "A2P gate check", summary: "Launch requirements receive final verification" },
    { key: "launched", label: "Launched", summary: "Your acquisition system is live" },
    { key: "active", label: "Active", summary: "Optimization and ongoing management" },
  ],
  tier_2: [
    { key: "brand-intake", label: "Brand intake", summary: "Voice, audience, and assets collected" },
    { key: "style", label: "Style direction", summary: "Creative direction and visual language aligned" },
    { key: "batch", label: "First batch in production", summary: "Initial content set is being created" },
    { key: "internal-review", label: "Our review", summary: "The team is checking quality and fit" },
    { key: "approval", label: "Your approval", summary: "Content is ready for client review" },
    { key: "launch", label: "Campaign launch", summary: "Approved brand campaign goes live" },
    { key: "calendar", label: "Active content calendar", summary: "Ongoing content delivery and cadence" },
  ],
};
